import { render, staticRenderFns } from "./slproductlog.vue?vue&type=template&id=16087352&"
import script from "./slproductlog.vue?vue&type=script&lang=js&"
export * from "./slproductlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports